const PERIOD_IN_MONTHS = 1

export const MEMBERSHIP = {
    PERIOD_IN_MONTHS
}
